import axios from 'axios';
import { API_URL } from '../config';

const AUTH_API_URL = `${API_URL}/auth/`;

// Create axios instance with credentials for auth requests
const authAxios = axios.create({
  baseURL: AUTH_API_URL,
  withCredentials: true, // Send/receive cookies
});

// const register = async (name, email, password, role) => {
//   const response = await authAxios.post('register', {
//     name,
//     email,
//     password,
//     role,
//   });
//   return response.data;
// };

const login = async (email, password) => {
  const response = await authAxios.post('login', {
    email,
    password,
  });

  if (response.data.data) {
    // Store only user info in sessionStorage (not the token - it's in httpOnly cookie)
    // Token is kept for backward compatibility during transition
    const { user, token } = response.data.data;
    sessionStorage.setItem('user', JSON.stringify({ user, token }));
  }
  return response.data;
};

const logout = async () => {
  try {
    // Call logout endpoint to clear httpOnly cookies on server
    await authAxios.post('logout');
  } catch (error) {
    console.error('Logout API error:', error);
  } finally {
    // Always clear local storage regardless of API success
    sessionStorage.removeItem('user');
  }
};

const getCurrentUser = () => {
  const userData = sessionStorage.getItem('user');
  if (!userData) return null;
  try {
    const parsed = JSON.parse(userData);
    // Return full object with token for API calls
    // Structure: { user: {...}, token: "..." }
    return parsed;
  } catch {
    return null;
  }
};

/**
 * Verify current session with server
 * Useful for checking if session is still valid on app load
 */
const verifySession = async () => {
  try {
    const response = await authAxios.get('verify');
    return response.data;
  } catch (error) {
    // Session invalid - clear local storage
    sessionStorage.removeItem('user');
    throw error;
  }
};

const AuthService = {
  // register,
  login,
  logout,
  getCurrentUser,
  verifySession,
};

export default AuthService; 